import { IDashboardState } from '../../dashboard/interfaces/dashboard.interface';

export const initialDashboardState: IDashboardState = {
    counts: {
        pendingContactEnquiries: 0,
        pendingAndProcessingOrders: 0,
    },
};
